import styled from 'styled-components'
import { tokens } from '@arvoreeducacao/bonsai-ds'

export const EnglishLevelWrapper = styled.li<{ isCEFR?: boolean, selected?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  width: ${({ isCEFR }) => (isCEFR ? '205px' : '82px')};
  height: ${({ isCEFR }) => (isCEFR ? '99px' : '76px')};
  background-color: ${({ selected }) => selected ? tokens.colors.orange2Light : tokens.colors.tertiary};
  border-radius: ${tokens.radius.xlarge};
  cursor: pointer;
  box-shadow: ${tokens.shadows.downMedium};
  margin-top: 10px;
  justify-content: center;

  transition: ${tokens.transitions.motionModerate2};

  @media (min-width: ${tokens.sizes.smScreen}px) {
    &:hover {
      background-color: ${tokens.colors.white};
      box-shadow: ${tokens.shadows.downLarge};
    }
  }

  @media (max-width: ${tokens.sizes.smScreen}px) {
    width: 88px;
    height: 88px;
  }
`
export const EnglishLevelText = styled.span<{ isCEFR?: boolean }>`
  margin: 2px 0 0 0;
  color: ${tokens.colors.dark6};
  text-align: center;
  font-size: ${tokens.fontSize.xxxlarge};
  font-weight: ${tokens.fontWeights.bold};
`

export const EnglishLevelSubText = styled.span`
  color: ${tokens.colors.dark6};
  text-align: center;
  font-size: ${tokens.fontSize.medium};

  @media (max-width: ${tokens.sizes.smScreen}px) {
    display: none;
  }
`
